var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#506D85",
    fillRule: "nonzero",
    stroke: "#506D85",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.904 16.545h.171c1.568-.028 2.837-.603 3.774-1.705 2.06-2.426 1.718-6.585 1.68-6.982-.133-2.98-1.482-4.405-2.596-5.07-.83-.497-1.798-.766-2.88-.788h-.09c-.595 0-1.762.1-2.88.766-1.124.665-2.495 2.09-2.628 5.092-.038.397-.38 4.556 1.68 6.982.932 1.102 2.2 1.677 3.769 1.705zm-4.02-8.547c0-.017.005-.033.005-.045.177-4.008 2.901-4.438 4.068-4.438h.064c1.446.033 3.903.648 4.069 4.438 0 .017 0 .034.005.045.005.04.38 3.84-1.322 5.842-.675.794-1.574 1.185-2.757 1.196h-.053c-1.178-.011-2.083-.402-2.752-1.196-1.697-1.99-1.333-5.808-1.327-5.842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.99 23.443v-.016c0-.045-.006-.09-.006-.14-.032-1.107-.102-3.695-2.425-4.522l-.053-.017c-2.415-.643-4.422-2.096-4.443-2.113a.703.703 0 0 0-1.007.184c-.23.341-.15.81.177 1.051.091.067 2.222 1.616 4.887 2.331 1.247.464 1.387 1.856 1.424 3.13 0 .051 0 .096.005.14.006.504-.026 1.28-.112 1.728-.867.514-4.266 2.292-9.437 2.292-5.15 0-8.57-1.784-9.442-2.298-.086-.447-.123-1.224-.113-1.727 0-.045.006-.09.006-.14.037-1.274.176-2.666 1.423-3.13 2.666-.716 4.797-2.27 4.888-2.331a.775.775 0 0 0 .176-1.051.703.703 0 0 0-1.006-.185c-.022.017-2.018 1.47-4.443 2.113a.653.653 0 0 0-.053.017c-2.324.833-2.393 3.421-2.425 4.522 0 .05 0 .095-.006.14v.017c-.005.29-.01 1.783.273 2.532.054.146.15.269.279.352.16.112 4.009 2.672 10.448 2.672 6.44 0 10.288-2.565 10.449-2.672a.742.742 0 0 0 .278-.352c.268-.743.263-2.236.257-2.527z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1e40555243f4b0baf88d00303166ba03.svg";
export { ForwardRef as ReactComponent };